import React, { createContext, useContext, useEffect, useState } from "react"
import JWTApi, { IUser } from "./JWTApi"
import { useDialog } from "../dialog/DialogProvider"
import LoginDialog from "./LoginDlg"
import _ from "lodash"

interface ILoginContext {
    isLoggedIn:boolean,
    login:(onLogin?:Function) => void
    logout:() => void
}

interface ILoginProps {
    api:JWTApi
    children:React.ReactElement|React.ReactElement[]
    loginDialog?:React.ReactElement
    required?:boolean
    onAuth?:(user:IUser) => void
}

const LoginContext = createContext<ILoginContext>({} as any)
const useLogin = () => useContext(LoginContext)
export default useLogin

export function LoginContextProvider(props:ILoginProps) {
    const {api} = props
    const [isLoggedIn,setIsLoggedIn] = useState<boolean>(false)
    const {dialogs,openDialog,closeDialog} = useDialog()

    const login = (onLogin?:Function) => {
        if (_.findIndex(dialogs, d => d.id=="login")<0) {            
            openDialog({id:"login",children:props.loginDialog || <LoginDialog api={api} onLogin={onLogin}/>,canClose:()=>!props.required})
        }
    }

    const onAuth = async (user:IUser|null) => {
        setIsLoggedIn(!!user)
        if (!user && props.required) login()
        else if (!!user) {
            closeDialog()
            props.onAuth?.(user)
        }
    }

    const logout = () => props.api.logout()

    useEffect(() => {
        api.on("auth", onAuth)
        if (!api.isLoggedIn) api.auth()
        return () => { api.removeListener("auth", onAuth) }
    }, [])

    return <LoginContext.Provider value={{isLoggedIn,login,logout}}>
        {props.children}
    </LoginContext.Provider>
}